module.exports = __webpack_public_path__ + "static/assets/mdi-glasses.svg";